export const INVOICE_STATUS = {
  OPEN: 0,
  IN_DELIVERY: 1,
  DELIVERED: 2,
  PAID: 3,
  DUE: -100,
  VALUTA: -200,
} as const;
